import styled, { css } from 'styled-components';

export const StyledKakarikoDates = styled.div`
  ${(props: { theme: any }) => {
    return css`
      .dates {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
      }

      .error {
        color: ${props.theme.warningBase};
        color: var(--warning-base);
      }
    `;
  }}
`;
